import { type ConditionFlowNode, getElseHandleId } from '@lighthouse/shared'
import { useUpdateNodeInternals } from '@xyflow/react'
import isDeepEqual from 'fast-deep-equal'
import React, { memo, useMemo } from 'react'
import { useUpdateEffect } from 'react-use'

import { useIsDisabledWithVersion } from '@/hooks/useIsDisabledWithVersion'

import { useErrorMap } from '../../hook/useErrorMap'
import { validateNode } from '../../utils/nodeValidator'
import { NodeSourceHandle, NodeTargetHandle } from '../Handle'
import NodeCard from './NodeCards'
import * as SC from './styles'

interface ConditionNodeProps extends ConditionFlowNode {
    isConnectable?: boolean
}

const handleStartTop = 64

const handleGap = 68

const ConditionNode: React.FC<ConditionNodeProps> = props => {
    const { selected, id, type, data, isConnectable } = props
    const disabledWithVersion = useIsDisabledWithVersion()
    // const appId = useCurrentAppId()
    const { nodeType, name, status, config } = data
    const { filterGroup } = config
    const updateNodeInternals = useUpdateNodeInternals()
    useUpdateEffect(() => {
        updateNodeInternals(id)
    }, [filterGroup])

    const errorMap = useErrorMap(config)
    // const dsId = config && 'dataSourceId' in config ? config.dataSourceId || '' : ''
    // const dataSource = useDataSource(appId, dsId)
    // const nodeDepsName = dataSource?.name || '请选择数据表'
    // const sourceHandles = Array.from({ length: filterGroup.length }, (_, index) => index)
    const errorMessage = useMemo(() => !validateNode(props) || errorMap?.[id], [errorMap, id, props])
    const elseHandleId = getElseHandleId()
    return (
        <SC.NodeWrapper selected={selected} status={status?.status}>
            <NodeCard nodeType={nodeType} errorMessage={errorMessage} data={data} />
            <NodeTargetHandle {...props} />
            {filterGroup.map((item, index) => (
                <NodeSourceHandle
                    id={id}
                    key={item.id}
                    isConnectable={isConnectable}
                    handleId={item.id}
                    style={{ top: handleStartTop + index * handleGap }}
                />
            ))}
            <NodeSourceHandle
                id={id}
                isConnectable={isConnectable}
                handleId={elseHandleId}
                style={{ top: handleStartTop + filterGroup.length * handleGap }}
            />
        </SC.NodeWrapper>
    )
}

export default memo(ConditionNode, (prevProps, nextProps) => {
    return isDeepEqual(prevProps, nextProps) && prevProps.selected === nextProps.selected
})
